import { render, staticRenderFns } from "./NoMobile.vue?vue&type=template&id=ce45224c&scoped=true&"
import script from "./NoMobile.vue?vue&type=script&lang=js&"
export * from "./NoMobile.vue?vue&type=script&lang=js&"
import style0 from "./NoMobile.vue?vue&type=style&index=0&id=ce45224c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce45224c",
  null
  
)

export default component.exports